// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Bl1n","bigColWidth":"Table_bigColWidth__1tgNu","biggerColWidth":"Table_biggerColWidth__Zw3aH","row":"Table_row__2D8Ix","col":"Table_col__3rDW2"};